
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/concierge",
      function () {
        return require("private-next-pages/concierge/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/concierge"])
      });
    }
  